import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import HeaderQuoteAi from './headerQuoteAi';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const InsuredInformationPage = () => {
  const [formData, setFormData] = useState({
    insuredName: '',
    nccId: '',
  });

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    insuredName: false,
    nccId: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: false }); // Reset error on change
  };

  const handleSave = () => {
    let newErrors = {
      insuredName: !formData.insuredName.trim(),
      nccId: !formData.nccId.trim(),
    };

    setErrors(newErrors);

    if (!newErrors.insuredName && !newErrors.nccId) {
      toast.success('Form submitted successfully!', {
        position: 'top-right',
        autoClose: 3000,
      });
    } else {
      toast.error('Please fill all required fields!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleCancel = () => {
    if (!formData.insuredName.trim() && !formData.nccId.trim()) {
      toast.error('Cannot cancel an empty form!', {
        position: 'top-right',
        autoClose: 3000,
      });
    } else {
      toast.warn('Form canceled!', {
        position: 'top-right',
        autoClose: 3000,
      });
      setFormData({ insuredName: '', nccId: '' }); // Reset form fields
      navigate('/quoteAI/InsuredInformationPage'); // Navigate to desired page
    }
  };

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            {/* <Button variant="outline-back" onClick={() => navigate("/quoteAI/InsuredInformationPage")}>Back</Button> */}
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/ContactInformationPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button
                              variant="outline-cancel"
                              className="button-gap"
                              onClick={handleCancel}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="primary-save"
                              className="button-gap"
                              onClick={handleSave}
                            >
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Insured Information
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                {/* Business Name */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Insured Name <span className="required-star">*</span>{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Insured Name"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Eutaw Methodist Church"
                                      name="insuredName"
                                      value={formData.insuredName}
                                      onChange={handleChange}
                                      isInvalid={errors.insuredName}
                                    />
                                    {errors.insuredName && (
                                      <Form.Control.Feedback type="invalid">
                                        This field is required.
                                      </Form.Control.Feedback>
                                    )}
                                  </Form.Group>
                                </Col>

                                {/* FEIN/TaxID */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>FEIN/TaxID</Form.Label>
                                    <Form.Control type="text" placeholder="99-9999999" />
                                  </Form.Group>
                                </Col>

                                {/* Primary Business State */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Primary Business State{' '}
                                      <span className="required-star">*</span>
                                    </Form.Label>
                                    <Form.Select>
                                      <option>Alabama</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* Website */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Website</Form.Label>
                                    <Form.Control type="url" placeholder="http://example.com" />
                                  </Form.Group>
                                </Col>

                                {/* NCC/Rating Bureau ID */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      NCC/Rating Bureau ID{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="NCC/Rating Bureau ID"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="99-9999999"
                                      name="nccId"
                                      value={formData.nccId}
                                      onChange={handleChange}
                                      isInvalid={errors.nccId}
                                    />
                                    {errors.nccId && (
                                      <Form.Control.Feedback type="invalid">
                                        This field is required.
                                      </Form.Control.Feedback>
                                    )}
                                  </Form.Group>
                                </Col>

                                {/* Governing Class Code */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Governing Class Code{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Governing Class Code"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Select>
                                      <option>Select</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* Annual Payroll */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Annual Payroll <span className="required-star">*</span>{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Annual Payroll"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="$" />
                                  </Form.Group>
                                </Col>

                                {/* Full-time Employees */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Number of Employees (Full Time)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Employees" />
                                  </Form.Group>
                                </Col>

                                {/* Part-time Employees */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Number of Part Time Employees</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Employees" />
                                  </Form.Group>
                                </Col>

                                {/* Years in Business */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Years in Business{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Years in Business"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="Enter Employees" />
                                  </Form.Group>
                                </Col>

                                {/* Years as Owner */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Years as Owner of this Business</Form.Label>
                                    <Form.Control type="text" placeholder="$" />
                                  </Form.Group>
                                </Col>

                                {/* Prior Insurance */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Do You Have Prior Insurance</Form.Label>
                                    <Form.Select defaultValue="">
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      <option value="yes">Yes</option>
                                      <option value="no">No</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>

                          {/* Additional Business Details Section */}
                          <Card className="formpage-card">
                            <Card.Header className="formpage-card-header">
                              Additional Business Details
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                {/* DBA */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>DBA</Form.Label>
                                    <Form.Control type="text" value="Alabama" readOnly />
                                  </Form.Group>
                                </Col>

                                {/* Legal Structure */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>
                                      Legal Structure of the Business{' '}
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Legal Structure of the Business"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      ></ReactTooltip>
                                    </Form.Label>
                                    <Form.Select>
                                      <option>Select</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* NAICS */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>NAICS</Form.Label>
                                    <Form.Select>
                                      <option>Select</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* SIC */}
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>SIC</Form.Label>
                                    <Form.Select>
                                      <option>Select</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                {/* Description */}
                                <Col xs={12} sm={12} md={12} lg={8} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label>Description of Business Operations</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Please add description"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsuredInformationPage;
